export default "__VITE_ASSET__8_JwcG10__"